import React from "react";
import GavelIcon from "@mui/icons-material/Gavel";
import { PageHeader } from "../../../shares/dashboard/DashboardWidgets";

/**
 * Class rules.
 *
 * Three fixes beyond styling:
 *  - the page was min-h-screen + items-center, vertically centring fifteen
 *    paragraphs so the list started below the fold on short windows;
 *  - every rule had `hover:text-danger`, turning the text red on mouseover for
 *    no reason, which read as an error state;
 *  - the numbers inside the copy were Latin digits in otherwise Persian text.
 *
 * Rules are numbered because they are referred to by number, so the counter is
 * information rather than decoration.
 */
const RULES = [
    "در زمان ثبت نام، هزینه ثبت نام بدون احتساب هزینه جزوات دریافت می‌شود.",
    "پس از ثبت‌نام کلاس‌ها به هیچ عنوان امکان تغییر گروه و جابجایی بین گروه‏ها وجود نخواهد داشت. (فقط امکان انصراف وجود دارد)",
    "غیبت بیش از ۵ جلسه درکلاس‌ها (مجاز یا غیرمجاز) به منزله انصراف است.",
    "در صورتی که دانش‌آموز به مدت ۵ هفته‌ی متوالی نمره‌ای زیر میانگین کلاس کسب کند، مدرس کلاس بنابر صلاح دید می‌تواند مانع از حضور دانش‌آموز در کلاس ‌شود.",
    "هر دانش‌آموز فقط و فقط در زمان مقرر گروه خود در کلاس و امتحان ‌می‌تواند شرکت کرده و جابجایی بین گروه‌ها امکان‌پذیر نیست (حتی برای یک جلسه) و غیبت در امتحانات تحت هر شرایطی نمره صفر را برای دانش‌آموز به همراه دارد و امتحانات نمره‌ی منفی دارند.",
    "فقط دانش‌آموز با میانگین درصد بالای ۶۰٪ برای سال آینده ثبت‌نام خواهد شد.",
    "ارسال تکالیف هفتگی بعد از زمان معین امکان‌پذیر نیست.",
    "در صورت عدم تحویل تکلیف برای دانش‌آموز درصد صفر لحاظ می‌شود. کسب ۳ نمره صفر در تکالیف به منزله انصراف است.",
    "کلیه‌ی کلاس‌ها در روزهای تعطیل برگزار می‌شود.",
    "مدرس کلاس می‌تواند بنا به صلاح دید خود و شرایط کلاس‌ها را به صورت آنلاین یا حضوری برگزار کند.",
    "در این کلاس مطالب کتب مربوط به ریاضی ۱ (دهم)، ریاضی ۲، حسابان ۱ (یازدهم)، ریاضی ۳ و حسابان ۲ (دوازدهم) پوشش داده می‌شود.",
    "درصورت غیبت در کلاس حضوری، امکان استفاده از فیلم‌های آموزشی وجود نخواهد داشت.",
    "در کلاس حضوری، استفاده از پوشش مناسب مدرسه برای حضور در کلاس‌ها الزامیست؛ در غیر این صورت از حضور دانش‌آموز در کلاس ممانعت به عمل می‌آید.",
    "از حضور دانش‌آموز با تاخیر بیش از ۱۰ دقیقه درکلاس جلوگیری می‌شود.",
    "در صورت ایجاد بی‌نظمی، دانش آموز از ادامه‌ی حضور در کلاس محروم می‌شود.",
];

const Rules = () => {
    return (
        <div className="flex flex-col gap-xl pb-4xl">
            <PageHeader
                title="قوانین کلاس‌ها"
                description="شرایطی که با ثبت‌نام پذیرفته‌ای"
                icon={GavelIcon}
            />

            <ol className="flex max-w-[80ch] flex-col gap-xs">
                {RULES.map((rule, index) => (
                    <li
                        key={rule}
                        style={{ "--i": Math.min(index, 8) }}
                        className="dash-rise flex gap-md rounded-card border border-rule-subtle bg-surface p-lg"
                    >
                        <span
                            aria-hidden="true"
                            className="flex h-[2.8rem] w-[2.8rem] shrink-0 items-center justify-center rounded-pill bg-primary-soft text-sm font-semibold tabular-nums text-primary"
                        >
                            {(index + 1).toLocaleString("fa-IR")}
                        </span>
                        <p className="text-base leading-relaxed text-ink-muted">
                            {rule}
                        </p>
                    </li>
                ))}
            </ol>
        </div>
    );
};

export default Rules;
